<template>
    <div class="Page HealthGuide">

      <h1>Health Guide</h1>
      <button v-if="ShowTakeSurveyButton" title="Take the health guide survey" :class="SurveyButtonClasses" @click="ShowSurveyModal">
        Take the Health Guide Survey
      </button>
      <div>
        <p v-if="!Survey.length">After taking the survey, you will see a 30 day health guide right here. You can take the survey again every 30 days.</p>
        <p v-if="Survey.length && !ShowTakeSurveyButton">Retake the survey in {{ DaysToRetakeSurvey }} day{{ DaysToRetakeSurvey===1?'':'s' }}</p>
      </div>

      <div v-if="Survey.length">
        <el-table stripe style="width: 100%" :data="Survey">
            <el-table-column
                min-width="100"
                prop="id"
                label="ID"
                :width="100"
            >
            </el-table-column>
            <el-table-column
                min-width="100"
                prop="will_power"
                label="Will Power"
                :width="180"
            >
            </el-table-column>
            <el-table-column
                min-width="220"
                prop="health_objectives"
                label="Health Objectives"
            >
                <template v-slot:default="props">
                    <div v-html="formatHO(props.row)"></div>
                </template>
            </el-table-column>
            <el-table-column v-if="ShowColumn('gout')"
                min-width="100"
                prop="gout"
                label="Gout"
                :width="120"
            >
                <template v-slot:default="props">
                    <div class="table-actions">
                        <font-awesome-icon v-if="props.row.gout" icon="check" class="text-success" />
                    </div>
                </template>
            </el-table-column>
            <el-table-column v-if="ShowColumn('gout')"
                min-width="100"
                prop="gout_warning_read"
                label="Gout Warning Read"
                :width="250"
            >
                <template v-slot:default="props">
                    <div class="table-actions">
                        <font-awesome-icon v-if="props.row.gout_warning_read" icon="check" class="text-success" />
                    </div>
                </template>
            </el-table-column>
            <el-table-column v-if="ShowColumn('diabetes')"
                min-width="100"
                prop="diabetes"
                label="Diabetes"
                :width="180"
            >
                <template v-slot:default="props">
                    <div class="table-actions">
                        <font-awesome-icon v-if="props.row.diabetes" icon="check" class="text-success" />
                    </div>
                </template>
            </el-table-column>
            <el-table-column v-if="ShowColumn('diabetes')"
                min-width="100"
                prop="diabetes_warning_read"
                label="Diabetes Warning Read"
                :width="300"
            >
                <template v-slot:default="props">
                    <div class="table-actions">
                        <font-awesome-icon v-if="props.row.diabetes_warning_read" icon="check" class="text-success" />
                    </div>
                </template>
            </el-table-column>
            <el-table-column v-if="ShowColumn('high_blood_pressure')"
                min-width="100"
                prop="high_blood_pressure"
                label="High Blood Pressure"
                :width="250"
            >
                <template v-slot:default="props">
                    <div class="table-actions">
                        <font-awesome-icon v-if="props.row.high_blood_pressure" icon="check" class="text-success" />
                    </div>
                </template>
            </el-table-column>
            <el-table-column v-if="ShowColumn('high_blood_pressure')"
                min-width="100"
                prop="high_blood_pressure_warning_read"
                label="High Blood Pressure Warning Read"
                :width="400"
            >
                <template v-slot:default="props">
                    <div class="table-actions">
                        <font-awesome-icon v-if="props.row.high_blood_pressure_warning_read" icon="check" class="text-success" />
                    </div>
                </template>
            </el-table-column>
            <!-- <el-table-column :width="120" fixed="right" label="Actions" label-class-name="text-center">
                <template v-slot:default="props">
                    <div class="table-actions text-center">
                        <n-button
                            @click="handleEdit(props.$index, props.row)"
                            class="edit"
                            type="warning"
                            size="sm"
                            round
                            icon
                        >
                            <font-awesome-icon icon="pencil" />
                        </n-button>
                        <n-button
                            @click="handleDelete(props.$index, props.row)"
                            class="remove"
                            type="danger"
                            size="sm"
                            round
                            icon
                        >
                            <font-awesome-icon icon="trash-can" />
                        </n-button>
                    </div>
                </template>
            </el-table-column> -->
        </el-table>

        <section v-if="Survey" class="ThirtyDayPlan">
            <header class="mt-5">
                <h2>Thirty Day Health Guide</h2>
            </header>
            <div class="row">
                <div v-for="index in 30" :key="index" :set="ThePlan = Plan(index)" class="col day">
                    <h4>Day {{ index }}</h4>
                    <GuideMeals :typeOfMeal="ThePlan.meals"></GuideMeals>
                    <hr class="m-lr15">
                    <GuideGreenDrinks :typeOfGD="ThePlan.GreenDrinks"></GuideGreenDrinks>
                    <hr class="m-lr15">
                    <div class="p-tb0" :class="{'p-b15': !ThePlan.DopamineFast}">
                        <b>Exercise:</b><br><span v-if="!ThePlan.Exercise">No </span>Exercise
                    </div>
                    <hr v-if="ThePlan.DopamineFast" class="m-lr15">
                    <div v-if="ThePlan.DopamineFast" class="p-tb0">
                        <b>1 more thing:</b><br>Dopamine Fast
                    </div>
                </div>
            </div>
        </section>
      </div>

      <modal :class="{show:modals.Survey.show}" :show-close="true" headerClasses="justify-content-center" type="Large" :CloseFunc="CloseSurveyModal">
        <template v-slot:header>
          <h4 class="title title-up">{{ modals.Survey.title }}</h4>
        </template>
        <Survey
            :Survey="modals.Survey.Survey"
            :InsertNew="modals.Survey.InsertNew"
            @CloseSurveyModal="CloseSurveyModal"
        ></Survey>
      </modal>

    </div>
</template>
<script>
import { Modal } from "@/components";
import { ElTable, ElTableColumn } from "element-plus";
import Survey from '../Components/AddEditGuideSurvey';
import GuideMeals from '../Components/Guide_Meals';
import GuideGreenDrinks from '../Components/Guide_GreenDrinks';

export default {
    name: 'HealthGuide',
    components: {
        [ElTable.name]: ElTable,
        [ElTableColumn.name]: ElTableColumn,
        Modal,
        Survey,
        GuideMeals,
        GuideGreenDrinks
    },
    data() {
        return {
            // ToDo: Add ability to mark recipes as 'weight loss', 'breakfast', or 'lunch' and link to the recipes page with the weight loss column checked
            Every7Days: [7,14,21,28],
            After7Days: [8,15,22,29],
            modals: {
                Survey: {
                    show: false,
                    title: 'Health Guide Survey',
                    InsertNew: true,
                    Survey: {}
                }
            },
            WindowWidth: window.innerWidth
        };
    },
    computed: {
        Surveys() {
            return this.$store.getters.HealthGuideSurveys_Get();
        },
        Survey() {
            return this.Surveys.length ? [this.Surveys[this.Surveys.length-1]] : [];
        },
        UserID() {
            return this.$store.getters.userGetID();
        },
        ShowTakeSurveyButton() {
            let ShowIt = !!(this.UserID && !this.Surveys.length);
            if (!ShowIt && this.UserID)
            {
                let Today = new Date();
                let Taken = new Date(this.Survey[0].created_at.replace('T', ' ').split('.')[0]);
                ShowIt = Today > Taken.setDate(Taken.getDate() + 30);
            }
            return ShowIt;
        },
        SurveyButtonClasses() {
            return {
                'btn': true,
                'btn-primary': true,
                'font-weight-bold': true,
                'mt-0': true,
                'ml-4': this.WindowWidth >= 500,
                'pull-right': this.WindowWidth >= 500
            }
        },
        DaysToRetakeSurvey() {
            if (!this.Surveys.length) { return ''; }
            let one_day = 1000 * 60 * 60 * 24;
            let Today = new Date();
            let Taken = new Date(this.Survey[0].created_at.replace('T', ' ').split('.')[0]);
            return Math.round((Taken.setDate(Taken.getDate() + 30) - Today) / one_day);
        }
    },
    mounted() {
        this.GetSurvey();
        window.addEventListener('resize', this.handleResize)
    },
    methods: {
        handleResize() {
            this.WindowWidth = window.innerWidth;
        },
        GetSurvey() {
            if (this.UserID) { this.$store.dispatch('HealthGuideSurveys_FindByUser', this.UserID); }
        },
        ShowSurveyModal() {
            this.modals.Survey.Survey = this.Survey;
            this.modals.Survey.show = true;
        },
        CloseSurveyModal() {
            this.modals.Survey.Survey = {};
            this.modals.Survey.title = 'Health Guide Survey';
            this.modals.Survey.InsertNew = true;
            this.modals.Survey.show = false;
        },
        ShowColumn(prop) {
            if (typeof this.Survey[0] === 'undefined') { return false; }
            let Return = true;
            let ColumnsToCheck = ['gout', 'diabetes', 'high_blood_pressure'];
            if (ColumnsToCheck.indexOf(prop) > -1)
            {
                if (!this.Survey[0][prop]) { Return = false; }
            }
            return Return;
        },
        formatHO(row) {
            if (typeof row === 'undefined') { return ''; }
            let Data = '';
                    let HOs = [];
                    row.health_objectives.forEach(ho => {
                        HOs.push(ho.objective);
                    });
                    Data = HOs.join('<br>');
            return Data;
        },
        Plan(day) {
            let plan = {
                meals: 'TwoWhatever',
                GreenDrinks: 'TwoWhatever',
                Exercise: false,
                DopamineFast: false
            };
            if (typeof this.Survey[0] === 'undefined') { return plan; }
            if (day > 7)
            {
                if (this.Every7Days.indexOf(day) === -1) { plan.Exercise = true; }
                plan.meals = 'OneAndOne';
                plan.GreenDrinks = 'OneAndOne';
            }
            if (day > 14)
            {
                plan.meals = 'TwoStarch';
                plan.GreenDrinks = 'TwoStarch';
            }
            let WillPower = this.Survey[0].will_power;
            if ([3,4].indexOf(WillPower) > -1)
            {
                plan.meals = 'OneAndOne';
                plan.GreenDrinks = 'OneAndOne';
                if (day > 4 && this.Every7Days.indexOf(day) === -1) { plan.Exercise = true; }
                if (day > 7)
                {
                    plan.meals = 'TwoStarch';
                    plan.GreenDrinks = 'TwoStarch';
                }
            }
            if ([5,6,7].indexOf(WillPower) > -1)
            {
                plan.meals = 'TwoStarch';
                plan.GreenDrinks = 'TwoStarch';
                if (day >= 4 && this.Every7Days.indexOf(day) === -1) { plan.Exercise = true; }
            }
            if (WillPower >= 8) {
                // ToDo: Let's get the total number of days in the program and if it's more than 29,
                // let's not start with 2 fasting days for > 8 will_power
                if ([1,...this.After7Days].indexOf(day) > -1 || (WillPower > 8 && day === 2))
                {
                    plan.meals = 'Fast';
                    plan.GreenDrinks = 'Fast';
                    plan.Exercise = false;
                    plan.DopamineFast = true;
                }
                else
                {
                    plan.meals = 'TwoStarch';
                    plan.GreenDrinks = 'TwoStarch';
                    plan.Exercise = true;
                }
            }
            return plan;
        }
    },
    watch: {
        UserID() { this.GetSurvey(); }
    }
};
</script>

<style lang="scss">
.HealthGuide {
    .ThirtyDayPlan {
        h2 { margin: 0; }
        .day {
            flex-basis: auto; width: 20%; padding-top: 15px; padding-bottom: 15px; background: content-box white;

            h4 { margin-top: .5rem; padding-left: 15px; }
            > div { padding: 0 15px; }
            .m-lr15 { margin-right: 15px; margin-left: 15px; }
            .p-b15 { padding-bottom: 15px; }
        }
    }
    
}
</style>